module.exports = __webpack_public_path__ + "static/media/manage.web.b3b4558a.png";